import { render, staticRenderFns } from "./WinLoseMember.vue?vue&type=template&id=45bcfd10&scoped=true&"
import script from "./WinLoseMember.vue?vue&type=script&lang=ts&"
export * from "./WinLoseMember.vue?vue&type=script&lang=ts&"
import style0 from "./WinLoseMember.vue?vue&type=style&index=0&id=45bcfd10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bcfd10",
  null
  
)

export default component.exports